module.exports = "<div class=\"center\">\r\n  <div class=\"container\">\r\n    <h2>Selecteer eerst een klas en daarna een student om zijn of haar beoordelingsformulieren te zien</h2>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/students/no-student-selected/no-student-selected.component.html
// module id = ./src/app/students/no-student-selected/no-student-selected.component.html
// module chunks = main